export let CompanySizeNumber;
(function (CompanySizeNumber) {
  CompanySizeNumber[CompanySizeNumber["One"] = 1] = "One";
  CompanySizeNumber[CompanySizeNumber["TwoToFive"] = 5] = "TwoToFive";
  CompanySizeNumber[CompanySizeNumber["SixToTen"] = 10] = "SixToTen";
  CompanySizeNumber[CompanySizeNumber["ElevenToTwentyFive"] = 25] = "ElevenToTwentyFive";
  CompanySizeNumber[CompanySizeNumber["TwentySixToFifty"] = 50] = "TwentySixToFifty";
  CompanySizeNumber[CompanySizeNumber["FiftyOneToOneHundred"] = 100] = "FiftyOneToOneHundred";
  CompanySizeNumber[CompanySizeNumber["OneHundredOneToTwoHundred"] = 101] = "OneHundredOneToTwoHundred";
  CompanySizeNumber[CompanySizeNumber["TwoHundredOneToFiveHundred"] = 500] = "TwoHundredOneToFiveHundred";
  CompanySizeNumber[CompanySizeNumber["FiveHundredOneOrMore"] = 2147483647] = "FiveHundredOneOrMore";
  CompanySizeNumber[CompanySizeNumber["FiftyOneToTwoHundred"] = 200] = "FiftyOneToTwoHundred";
  CompanySizeNumber[CompanySizeNumber["TwoHundredOneToOneThousand"] = 1000] = "TwoHundredOneToOneThousand";
  CompanySizeNumber[CompanySizeNumber["OneThousandOneToTenThousand"] = 10000] = "OneThousandOneToTenThousand";
  CompanySizeNumber[CompanySizeNumber["TenThousandOneOrMore"] = 10001] = "TenThousandOneOrMore";
})(CompanySizeNumber || (CompanySizeNumber = {}));